import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const causesCriteriaKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    id: <U extends QueryKeyParam>(id: U) =>
      createQueryKey({
        all: [...keys, id] as const,
      }),
  });

const causesKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'causes'] as const,
    sisFields: [...keys, 'causes', 'sis-fields'] as const,
    criteria: causesCriteriaKeys([...keys, 'causes', 'criteria'] as const),
  });

export { causesKeys };
